/**
 * PlayerPreviewInfoRows — label/value row list for the player preview drawer's
 * data sections (SE-5494).
 * @module features/player-kanban/components/molecules/PlayerPreviewInfoRows
 */

export { default } from "./PlayerPreviewInfoRowsView";
export type {
  PlayerPreviewInfoLayout,
  PlayerPreviewInfoRowsViewProps,
} from "./PlayerPreviewInfoRowsView";
